export default __webpack_public_path__ + "static/media/masthead-angle-top-left.d6172639.svg";